/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

const levels = ['one', 'two', 'three'];
const MIN_LEVEL = 0;
const MAX_LEVEL = levels.length - 1;

export { MAX_LEVEL, MIN_LEVEL, levels };
